import React, { Fragment } from "react";
import Footer from "../../component/Other/Footer";
import Navbar from "../../component/Other/Navbar";
import PricingSection from "../../component/Other/Pricing";
const Pricing = (props) => {

    return (
        <Fragment>
            <div className="overflow-hidden">
                <Navbar type="light" />

                <PricingSection />

                <section>
                    <div className="container">
                        <h2 className="bold font__size--40 text__40-1024 text__40-md text__40-mm color__black">What's Included</h2>
                        <p className="normal font__size--16 text__16-1024 color__gray-2 mb-5">PavilionManager brings the essential project, financial and collaboration tools together. <br />
                            Use the same structure for every site, or publish custom configuration per project.</p>

                        <div className="row">
                            <div className="col-md-6 col-lg-4 mb-4">
                                <div className="wrapper__card-included h-100">
                                    <img src="./../images/profile-tick.png" className="mb-4" alt="" />
                                    <h5 className="bold font__size--20 text__20-1024 mb-2">Project operations</h5>
                                    <ul className="list normal font__size--16 text__16-1024 color__gray-2">
                                        <li>Create and manage projects</li>
                                        <li>Track milestones and tasks</li>
                                        <li>Assign workers and monitor progress</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-4 mb-4">
                                <div className="wrapper__card-included h-100">
                                    <img src="./../images/24-support.png" className="mb-4" alt="" />
                                    <h5 className="bold font__size--20 text__20-1024 mb-2">Organization access</h5>
                                    <ul className="list normal font__size--16 text__16-1024 color__gray-2">
                                        <li>Members and invites</li>
                                        <li>Admin and worker profiles</li>
                                        <li>Role-based governance</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-4 mb-4">
                                <div className="wrapper__card-included h-100">
                                    <img src="./../images/data.png" className="mb-4" alt="" />
                                    <h5 className="bold font__size--20 text__20-1024 mb-2">Configurable project shell</h5>
                                    <ul className="list normal font__size--16 text__16-1024 color__gray-2">
                                        <li>Published schema fields</li>
                                        <li>View and workflow definitions</li>
                                        <li>Permission policies</li>
                                        <li>Automation run history</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-4 mb-4">
                                <div className="wrapper__card-included h-100">
                                    <img src="./../images/shop-add.png" className="mb-4" alt="" />
                                    <h5 className="bold font__size--20 text__20-1024 mb-2">Procurement control</h5>
                                    <ul className="list normal font__size--16 text__16-1024 color__gray-2">
                                        <li>Procurement requests</li>
                                        <li>Approval and rejection flows</li>
                                        <li>Purchase orders and goods receipt</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-4 mb-4">
                                <div className="wrapper__card-included h-100">
                                    <img src="./../images/shield-tick.png" className="mb-4" alt="" />
                                    <h5 className="bold font__size--20 text__20-1024 mb-2">Ledger and payments</h5>
                                    <ul className="list normal font__size--16 text__16-1024 color__gray-2">
                                        <li>Ledger summary and journal</li>
                                        <li>Deposits and payment requests</li>
                                        <li>Approval OTP and payment proof</li>
                                        <li>CSV exports for reporting</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-4 mb-4">
                                <div className="wrapper__card-included h-100">
                                    <img src="./../images/profile-2user.png" className="mb-4" alt="" />
                                    <h5 className="bold font__size--20 text__20-1024 mb-2">Client and reporting hub</h5>
                                    <ul className="list normal font__size--16 text__16-1024 color__gray-2">
                                        <li>Client updates and approvals</li>
                                        <li>Invoices and certificates</li>
                                        <li>Risk, activity and analytics snapshots</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>

                <Footer />
            </div >
        </Fragment >
    );
};

export default Pricing;
